import React, {InputHTMLAttributes} from 'react'
import {FieldValues, FieldErrors} from 'react-hook-form'
import {ErrorMessage} from '@hookform/error-message'
import {KTSVG} from '../KTSVG'
import {KTText} from '../KTText'

interface Props
 extends InputHTMLAttributes<HTMLInputElement> {
 label?: string
 type: string
 id?: string
 name: string
 className?: string
 wrapperClassName?: string
 inputWrapperClassName?: string
 labelClassName?: string
 errorIconClassName?: string
 iconPath?: string
 showIcon?: boolean
 helperTextClass?: string
 helperText?: string
 register?: FieldValues
 errors?: FieldErrors | undefined
 endAdornment?: React.ReactNode
}

const TextField = ({
 label,
 className,
 showIcon = true,
 wrapperClassName,
 iconPath,
 labelClassName,
 errorIconClassName,
 name,
 required,
 type,
 id,
 onChange,
 onBlur,
 disabled = false,
 readOnly = false,
 step,
 autoComplete = 'off',
 value,
 maxLength,
 minLength,
 min,
 max,
 autoFocus,
 register,
 placeholder,
 helperTextClass,
 inputWrapperClassName,
 helperText,
 errors,
 endAdornment,
}: Props) => {
 return (
  <div className={`${wrapperClassName}`}>
   <div
    className={`${inputWrapperClassName} ${
     disabled && '!bg-[#F5F8FA]'
    } form-field-wrapper py-2 px-4 relative rounded-lg border border-solid border-[#E6EBF0] bg-white focus-within:border-[#000000]`}
   >
    {label && (
     <label
      htmlFor={id}
      className={`input-label ${labelClassName} relative pb-1 text-[#4E83E4] text-xs font-medium`}
     >
      {label}
      {required && (
       <span className='required-field pl-[2px]'>*</span>
      )}
     </label>
    )}
    <input
     type={type}
     step={step}
     name={name}
     id={id ?? name}
     className={`form-input ${className} !disabled:bg-blue-300 relative !disabled:text-[#33393D] text-[#33393D] pr-6 text-lg font-normal block w-full ${
      errors?.[name] && 'border-[#CC293F]'
     }`}
     placeholder={placeholder}
     onChange={onChange}
     onBlur={onBlur}
     disabled={disabled}
     readOnly={readOnly}
     value={value}
     autoComplete={autoComplete}
     autoFocus={autoFocus}
     minLength={minLength}
     maxLength={maxLength}
     min={min}
     max={max}
     {...register}
    />
    {((errors?.[name] && showIcon) ?? iconPath) && (
     <KTSVG
      path={`${iconPath ?? '/media/icons/icon_error.svg'}`}
      svgClassName={`${errorIconClassName} absolute bottom-[10px] z-11 right-[10px]`}
     />
    )}
    {endAdornment}
   </div>
   {helperText && !errors?.[name] && (
    <KTText className={helperTextClass}>
     {helperText}
    </KTText>
   )}
   {errors && (
    <ErrorMessage
     errors={errors}
     name={name}
     render={({message}) => (
      <p className='error-msg error-cls'>{message}</p>
     )}
    />
   )}
  </div>
 )
}

export {TextField}
